import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { ofActionCompleted, Select } from '@ngxs/store';
import { AccountsState } from 'src/app/states/accounts.state';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FetchAccountBilling } from 'src/app/states/accounts.actions';
import { PushMenuActiveAccountId } from 'src/app/states/menu.actions';
import ResponseHandlingHelper from 'src/app/helpers/response-handling-helper';
import { HttpErrorCode } from 'src/app/api/http-error-code.enum';
export class AccountBillingPageComponent {
    constructor(store, actions, router, route, formBuilder, title) {
        this.store = store;
        this.actions = actions;
        this.router = router;
        this.route = route;
        this.formBuilder = formBuilder;
        this.title = title;
        this.billing = null;
        this.gc = new Subject();
        /**
         * Określa czy aktualnie trwa pobieranie danych.
         */
        this.isLoadingBilling = false;
        /**
         * Token służący do anulowania pobierania danych.
         */
        this.cancellationToken = new Subject();
    }
    ngOnInit() {
        this.title.setTitle('Billing & Payment - Dataedo Account');
        this.initEvents();
    }
    initEvents() {
        this.route.params
            .pipe(takeUntil(this.gc))
            .subscribe(params => this.onPathChange(params));
        this.billingListener
            .pipe(takeUntil(this.gc))
            .subscribe(billing => this.billing = billing);
        this.actions
            .pipe(ofActionCompleted(FetchAccountBilling))
            .pipe(takeUntil(this.gc))
            .subscribe(event => this.onCompletedFetchBilling(event));
    }
    onPathChange(params) {
        this.accountId = parseInt(params.accountId, 10);
        this.store.dispatch(new PushMenuActiveAccountId(this.accountId));
        this.fetchData();
    }
    fetchData() {
        this.isLoadingBilling = true;
        this.cancellationToken.next();
        this.store.dispatch(new FetchAccountBilling(this.accountId, this.cancellationToken));
    }
    onCompletedFetchBilling(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = ResponseHandlingHelper.parse(event.result);
            if (response.isError && response.error.status === HttpErrorCode.Forbidden) {
                yield this.router.navigate(['/accounts', this.accountId]);
            }
            this.isLoadingBilling = false;
        });
    }
    ngOnDestroy() {
        this.cancellationToken.next();
        this.cancellationToken.complete();
        this.gc.next();
        this.gc.complete();
    }
}
tslib_1.__decorate([
    Select(AccountsState.billing)
], AccountBillingPageComponent.prototype, "billingListener", void 0);
